module.exports = __webpack_public_path__ + "img/cg1.543baf6f.jpg";